import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendCustomTrackingInfo } from '@panel/commons';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';

import { getPublisherTypeNameDL } from '@panel/commons/helpers';
import PublisherLevelSection from '../../../PublisherLevelSection';
import PublisherPermanencieSection from '../../../PublisherPermanencieSection';
import DisclaimerSection from '../../../DisclaimerSection';

import { ReputationOperations } from '../../../../ducks/reputation';
import { ScoreOperations, ScoreSelectors } from '../../../../ducks/score';

import { Container } from './styles';
import PublisherQualitySection from '../../../PublisherQualitySection';
import PublisherTaxResponseSection from '../../../PublisherTaxResponseSection';
import PublisherScoreSection from '../../../PublisherScoreSection';
import PublisherErrorSection from '../../../PublisherErrorSection';

const Score = ({ device, setRenderStatisticsDLSend, renderStatisticsDLSend, siteId, isPortalWithNewReputation }) => {
  const dispatch = useDispatch();
  const { getRatings, getReports, getQuality } = ReputationOperations;
  const { getScore } = ScoreOperations;

  const { isIntegrator, userLoggedId, publisherTypeId } = useSelector(userInfoSelectors.getuserInfoState);

  const { reputationLevel, responseRate, permanence, error, loading } = useSelector(ScoreSelectors.getReputationState);

  const reloadDispatch = () => {
    dispatch(getRatings());
    dispatch(getReports());
    dispatch(getQuality());
    if (isPortalWithNewReputation) {
      dispatch(getScore(null, siteId));
    }
  };

  useEffect(() => {
    if (loading === false && userLoggedId && !renderStatisticsDLSend) {
      sendCustomTrackingInfo({
        event: 'track_content_group',
        content_group: 'Panel',
        content_type: 'Estadisticas',
        user_reputation: reputationLevel.level,
        user_id: userLoggedId,
        user_type: getPublisherTypeNameDL(publisherTypeId)
      });
      setRenderStatisticsDLSend(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, reputationLevel.level, userLoggedId, renderStatisticsDLSend]);

  return !error ? (
    <Container device={device}>
      <PublisherScoreSection
        reputationLevel={reputationLevel}
        error={error}
        device={device}
        sendCustomTrackingInfo={sendCustomTrackingInfo}
      />
      <PublisherTaxResponseSection
        responseRate={responseRate}
        error={error}
        empty={!responseRate.level}
        device={device}
        reloadDispatch={reloadDispatch}
        sendCustomTrackingInfo={sendCustomTrackingInfo}
        isIntegrator={isIntegrator}
      />
      <PublisherLevelSection
        device={device}
        reloadDispatch={reloadDispatch}
        sendCustomTrackingInfo={sendCustomTrackingInfo}
      />
      <PublisherQualitySection
        device={device}
        reloadDispatch={reloadDispatch}
        sendCustomTrackingInfo={sendCustomTrackingInfo}
        branchId={reputationLevel.publisherId}
      />
      <PublisherPermanencieSection
        device={device}
        permanence={permanence}
        error={error}
        reloadDispatch={reloadDispatch}
      />
      <DisclaimerSection device={device} error={false} reloadDispatch={reloadDispatch} />
    </Container>
  ) : (
    <Container>
      <PublisherErrorSection reloadDispatch={reloadDispatch} device={device} />
    </Container>
  );
};

export default Score;
